import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ForumModel } from '../forum.model';
import { ForumService } from '../forum.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { FormValidatorService } from '@fi-app/utilities/fi-services/form-validator.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters/access-right-filters.component';
import { first } from 'rxjs/operators';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-forum-edit',
    templateUrl: './forum-edit.component.html',
    styleUrls: ['./forum-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-forum-edit' },
    standalone: false,
})
export class ForumEditComponent implements OnInit, AfterViewInit {
    @Input() forum: ForumModel;
    @ViewChild(AccessRightFiltersComponent, { static: false }) accessRightFilters: AccessRightFiltersComponent;
    @ViewChild('formContainerElement') formContainerElement: ElementRef;
    AccessRightFilterSettings: AccessRightFilterSettings;
    defaultContentLanguageId: number;

    constructor(
        private forumService: ForumService,
        private fiLoadingService: LoadingService,
        private saveChangesWarningService: SaveChangesWarningService,
        private formValidatorService: FormValidatorService,
        private stateService: FiStateService,
        private fiContentLanguageSharedService: FiContentLanguageSharedService,
        private fiUserDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        this.AccessRightFilterSettings = new AccessRightFilterSettings(
            ModuleType.ForumAdmin,
            false,
            false,
            ObjectTypes.Forum,
        );
        this.defaultContentLanguageId = this.getDefaultContentLanguageId();
    }

    ngAfterViewInit(): void {
        const getModelData = () => ({
            forum: this.forum,
        });

        this.accessRightFilters.onInitialized$.pipe(first()).subscribe(() => {
            this.saveChangesWarningService.start(getModelData);
        });
    }

    private getDefaultContentLanguageId(): number {
        return !!this.forum.Id
            ? this.fiContentLanguageSharedService.getContentLanguageIdByContentTranslation(this.forum.Names)
            : this.fiUserDataService.getContentLanguage();
    }

    saveForum() {
        if (!this.formValidatorService.validateForm(this.formContainerElement.nativeElement)) {
            this.formValidatorService.showErrorMessage();
        } else {
            const promise = this.forumService.saveForum(this.forum);
            this.fiLoadingService.trackPromise(promise);
            promise.then((data) => {
                this.forum.Id = data;
                this.saveChangesWarningService.stop();
                this.accessRightFilters.OnAccessRightFilterCollectionSaved();
                this.stateService.go(FiStateNames.Forum.List, {
                    filterType: SideListOptionType.ForumSharedToMe,
                });
            });
        }
    }
}
